'use strict';

var SiteSelectorPromptDialogDirective = function() {

  return {
    bindToController: true,
    scope: {},
    controller: 'SiteSelectorPromptDialogController',
    controllerAs: 'ccVM',
    link: function() {},
    templateUrl: 'dash/siteSelector/dialog/siteSelectorPromptDialog.tpl.html'
  };
};

module.exports = SiteSelectorPromptDialogDirective;


// WEBPACK FOOTER //
// ./src/app/dash/siteSelector/dialog/SiteSelectorPromptDialogDirective.js